import {
  Box,
  Grid,
  Typography,
  TextField,
  MenuItem,
  Autocomplete,
  Checkbox,
} from "@mui/material";
import styles from "../InternalTracker.module.css";
import RootComponents from "../../../components/common/RootComponents";
import { customTextColor } from "../../../utils/const";
import { FaLongArrowAltRight } from "react-icons/fa";
import { PiGenderIntersexLight } from "react-icons/pi";
import { CiMobile3 } from "react-icons/ci";
import { PiMailboxLight } from "react-icons/pi";
import { PiChairLight } from "react-icons/pi";
import { PiAddressBookLight } from "react-icons/pi";
import { PiNewspaperClippingLight } from "react-icons/pi";
import { PiIdentificationCardLight } from "react-icons/pi";
import { useNavigate } from "react-router-dom";
import { PiUserLight } from "react-icons/pi";
import { PiMapPinSimpleAreaLight } from "react-icons/pi";
import { gender } from "../../../utils/const2";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useSelector } from "react-redux";

const fieldStyle = {
  width: "100%",
  "& .MuiInputBase-root": {
    paddingLeft: "30px", // Adjust padding to make space for the icon
  },
  "& .MuiInputLabel-root": {
    left: "35px",
    fontSize: "14px ", // Adjust label position to align with input text
  },
  "& .MuiInputBase-input": {
    paddingBottom: "7px", // Add padding to the input text itself to make space for the icon
  },
  "& .MuiInputLabel-shrink": {
    left: "35px",
    fontSize: "14px  ", // Adjust label position when it shrinks
  },
  padding: "7px",
};

const InternalTrackerView = () => {
  const navigate = useNavigate();

  const profile = useSelector((state) => state.profile.data);

  const formik = useFormik({
    initialValues: {
      full_name: null,
      gender: null,
      mobile_no: null,
      email: null,
      current_location: null,
      prefer_location: null,
      work_authorization: null,
      prefer_tax_team: null,
    },
    validationSchema: Yup.object({
      full_name: Yup.string().required("Full Name is required"),
      gender: Yup.string().required("Gender is required"),
      mobile_no: Yup.string()
        .matches(/^\d+$/, "Mobile Number must be digits only")
        .required("Mobile Number is required"),
      email: Yup.string().required("Email is required"),
      current_location: Yup.string().required("Current Location is required"),
      prefer_location: Yup.string().required("Prefer Location is required"),
      work_authorization: Yup.string().required(
        "work Authorization is required"
      ),
      prefer_tax_team: Yup.string().required("Prefer Tax Term is required"),
    }),
    onSubmit: (values) => {
      // navigate("/internal-tracker-candidate", { state: { formik1: values, selectedFileName, row: row } })
    },
  });

  let prefer_tax_term;
  if (profile?.profile?.role === "BENCH_SALES_RECRUITER") {
    prefer_tax_term = [
      { id: "contract", name: "Contract" },
      { id: "contract_to_hire", name: "Contract To Hire" },
    ];
  } else {
    prefer_tax_term = [
      { id: "contract", name: "Contract" },
      { id: "contract_to_hire", name: "Contract To Hire" },
      { id: "full_Time", name: "Fulltime" },
      { id: "w2_with_benefit", name: "W2 Hourly Benefit" },
      { id: "w2_without_benefit", name: "W2 Hourly No Benefit" },
      { id: "1099", name: "1099" },
      { id: "working_in_all", name: "All" },
    ];
  }

  return (
    // <RootComponents>
    <Box className={styles.add_structure}>
      <Typography
        className={styles.add_heading}
        style={{ color: customTextColor }}
      >
        Internal Tracker
      </Typography>
      <Box className={styles.upload_resume_section}>
        <Box style={{ color: customTextColor }}>
          <Typography> Make your tracker for future submissions </Typography>
          <Typography
            sx={{ marginBottom: "0 !important", fontSize: "20px !important" }}
          >
            Get 50% Extra Relaxation in Recruitment Life
          </Typography>
        </Box>
        <button style={{ color: customTextColor }}>Upload Resume</button>
      </Box>

      <Grid container className={styles.candidate_field_section}>
        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          lg={6}
          sx={{ padding: "5px 10px 0 10px", position: "relative" }}
        >
          <Box className={styles.icon_style}>
            <PiUserLight style={{ fontSize: "25px" }} />
          </Box>
          <TextField
            id="standard-basic"
            label="Candidate Name"
            variant="standard"
            name="full_name"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.full_name}
            sx={fieldStyle}
          />
          {formik.touched.full_name && formik.errors.full_name ? (
            <div className={styles.error}>{formik.errors.full_name}</div>
          ) : null}
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          lg={6}
          sx={{ padding: "10px 10px 0 10px", position: "relative" }}
        >
          <Box className={styles.icon_style}>
            <PiGenderIntersexLight style={{ fontSize: "25px" }} />
          </Box>
          <TextField
            select
            label="Gender"
            name="gender"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.gender}
            sx={fieldStyle}
            variant="standard"
          >
            {gender.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
          {formik.touched.gender && formik.errors.gender ? (
            <div className={styles.error}>{formik.errors.gender}</div>
          ) : null}
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          lg={6}
          sx={{ padding: "10px 10px 0 10px", position: "relative" }}
        >
          <Box className={styles.icon_style}>
            <CiMobile3 style={{ fontSize: "25px" }} />
          </Box>
          <TextField
            id="standard-basic"
            label="Contact No"
            variant="standard"
            type="text"
            name="mobile_no"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.mobile_no}
            sx={fieldStyle}
          />
          {formik.touched.mobile_no && formik.errors.mobile_no ? (
            <div className={styles.error}>{formik.errors.mobile_no}</div>
          ) : null}
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          lg={6}
          sx={{ padding: "10px 10px 0 10px", position: "relative" }}
        >
          <Box className={styles.icon_style}>
            <PiMailboxLight style={{ fontSize: "25px" }} />
          </Box>
          <TextField
            id="standard-basic"
            label="E-Mail ID"
            variant="standard"
            type="text"
            name="email"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.email}
            sx={fieldStyle}
          />
          {formik.touched.email && formik.errors.email ? (
            <div className={styles.error}>{formik.errors.email}</div>
          ) : null}
        </Grid>

        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          lg={6}
          sx={{ padding: "10px 10px 0 10px", position: "relative" }}
        >
          <Box className={styles.icon_style}>
            <PiChairLight style={{ fontSize: "25px" }} />
          </Box>
          <TextField
            id="standard-basic"
            label="Current Job Profile"
            variant="standard"
            type="text"
            name="requirement_from"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.requirement_from}
            sx={fieldStyle}
          />
          {formik.touched.requirement_from && formik.errors.requirement_from ? (
            <div className={styles.error}>{formik.errors.requirement_from}</div>
          ) : null}
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          lg={6}
          sx={{ padding: "10px 10px 0 10px", position: "relative" }}
        >
          <Box className={styles.icon_style}>
            <PiAddressBookLight style={{ fontSize: "25px" }} />
          </Box>
          <TextField
            id="standard-basic"
            label="Total Experience "
            variant="standard"
            type="text"
            name="requirement_from"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.requirement_from}
            sx={fieldStyle}
          />
          {formik.touched.requirement_from && formik.errors.requirement_from ? (
            <div className={styles.error}>{formik.errors.requirement_from}</div>
          ) : null}
        </Grid>

        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          lg={6}
          sx={{ padding: "10px 10px 10px 10px", position: "relative" }}
        >
          <Box className={styles.icon_style}>
            <PiMapPinSimpleAreaLight style={{ fontSize: "25px" }} />
          </Box>
          <TextField
            label="Currecnt Locations "
            variant="standard"
            select
            name="current_location"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.current_location}
            sx={fieldStyle}
          />
          {formik.touched.current_location && formik.errors.current_location ? (
            <div className={styles.error}>{formik.errors.current_location}</div>
          ) : null}
        </Grid>

        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          lg={6}
          sx={{ padding: "10px 10px 10px 10px", position: "relative" }}
        >
          <Box className={styles.icon_style}>
            <PiMapPinSimpleAreaLight style={{ fontSize: "25px" }} />
          </Box>
          <TextField
            id="standard-basic"
            label="Prefer Location"
            variant="standard"
            type="text"
            name="prefer_location"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.prefer_location}
            sx={fieldStyle}
          />
          {formik.touched.prefer_location && formik.errors.prefer_location ? (
            <div className={styles.error}>{formik.errors.prefer_location}</div>
          ) : null}
        </Grid>

        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          lg={6}
          sx={{ padding: "10px 10px 10px 10px", position: "relative" }}
        >
          <Box className={styles.icon_style}>
            <PiIdentificationCardLight style={{ fontSize: "25px" }} />
          </Box>
          <TextField
            id="standard-basic"
            label="Work Authorization"
            variant="standard"
            type="text"
            name="work_authorization"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.work_authorization}
            sx={fieldStyle}
          />
          {formik.touched.work_authorization &&
          formik.errors.work_authorization ? (
            <div className={styles.error}>
              {formik.errors.work_authorization}
            </div>
          ) : null}
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          lg={6}
          sx={{ padding: "10px 10px 10px 10px", position: "relative" }}
        >
          <Box className={styles.icon_style}>
            <PiNewspaperClippingLight style={{ fontSize: "25px" }} />
          </Box>
          {/* <TextField
            label="Prefer Tax Term "
            variant="standard"
            select
            name="prefer_tax_team"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.prefer_tax_team}
            sx={fieldStyle}
          >
            {prefer_tax_term.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField> */}

          <Autocomplete
            multiple
            id="autocomplete-multi-select"
            options={prefer_tax_term || []}
            disableCloseOnSelect
            value={
              prefer_tax_term?.filter((tax_term) =>
                formik.values.prefer_tax_team?.includes(tax_term.id)
              ) || []
            }
            onChange={(event, value) => {
              const selectedPrefertaxterm = value?.map(
                (tax_term) => tax_term?.id
              );
              formik.setFieldValue("prefer_tax_team", selectedPrefertaxterm);
            }}
            onBlur={formik.handleBlur}
            getOptionLabel={(option) => option?.name || ""}
            renderOption={(props, option, { selected }) => (
              <MenuItem {...props}>
                <Checkbox
                  checked={selected}
                  sx={{ marginRight: 0, marginLeft: 0 }}
                />
                <span>{option?.name}</span>{" "}
              </MenuItem>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Prefer Tax Term"
                variant="standard"
                size="small"
                name="prefer_tax_team"
                sx={fieldStyle}
              />
            )}
            sx={{ backgroundColor: "#fff", width: "100%" }}
          />

          {formik.touched.prefer_tax_team && formik.errors.prefer_tax_team ? (
            <div className={styles.error}>{formik.errors.prefer_tax_team}</div>
          ) : null}
        </Grid>
      </Grid>

      <Box className={styles.add_consultant_btns}>
        <button onClick={() => navigate("/internal-tracker-candidate")}>
          Next Please <FaLongArrowAltRight />
        </button>
      </Box>
    </Box>
    // </RootComponents>
  );
};

export default InternalTrackerView;
